import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=bb057aca&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=bb057aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb057aca",
  null
  
)

export default component.exports